import { Button } from '@apps/web/components/ui/button';
import { cn } from '@apps/web/lib/utils';

// Pill styling shared by the Messages and Calls inbox filter rows.
//
// The filter row is one line that never wraps or scrolls. A phone column
// narrower than 23rem trims 2px of pill padding (static). When browser
// zoom-out plus a minimum font size makes the text outgrow the column,
// useFitToolbar steps the row down: compact trims padding and gaps, tight
// takes them to a minimum (the text itself cannot shrink under the clamp).
export const INBOX_PILL_COMPACT_CLASS =
    '@max-[23rem]/inbox:px-2 group-data-[fit-compact]/fit:px-2 group-data-[fit-tight]/fit:gap-0.5 group-data-[fit-tight]/fit:px-1 group-data-[fit-tight]/fit:tracking-tight';
export const INBOX_PILL_INACTIVE_CLASS = cn(
    'h-6 shrink-0 gap-1 rounded-full px-2.5 text-xs font-medium shadow-none bg-muted text-foreground hover:bg-muted/80',
    INBOX_PILL_COMPACT_CLASS,
);
export const INBOX_PILL_ACTIVE_CLASS = cn(
    'h-6 shrink-0 gap-1 rounded-full px-2.5 text-xs font-medium shadow-none bg-blue-100 text-blue-700 hover:bg-blue-100/80 hover:text-blue-700 dark:bg-blue-950/40 dark:text-blue-300',
    INBOX_PILL_COMPACT_CLASS,
);

export function InboxFilterPill({
    label,
    active,
    onClick,
}: {
    readonly label: string;
    readonly active: boolean;
    readonly onClick: () => void;
}) {
    return (
        <Button
            aria-pressed={active}
            className={cn(
                active ? INBOX_PILL_ACTIVE_CLASS : INBOX_PILL_INACTIVE_CLASS,
            )}
            onClick={onClick}
            size="sm"
            type="button"
            variant="ghost"
        >
            {label}
        </Button>
    );
}
